import React, { useState, useEffect } from 'react';
import { Typography } from '@material-ui/core';
import wordsToNumbers from 'words-to-numbers';
import alanBtn from '@alan-ai/alan-sdk-web';

import logo from './images/logo.png';
import { NewsCards, Modal } from './components';
import useStyles from './styles';

const App = () => {
  const [activeArticle, setActiveArticle] = useState(0);
  const [newsArticles, setNewsArticles] = useState([]);

  const classes = useStyles();

  useEffect(() => {
    alanBtn({
      key: 'ca3dfb8c13938aa0b4da4c8484f759a42e956eca572e1d8b807a3e2338fdd0dc/stage',
      onCommand: ({ command, articles, number }) => {
        if (command === 'newHeadlines') {
          setNewsArticles(articles);
          setActiveArticle(-1);
        }
        else if (command === 'highlight') {
          setActiveArticle((prevActiveArticle) => prevActiveArticle + 1);
        }
         else if (command === 'open') {
          const parsedNumber = number.length > 2 ? wordsToNumbers((number), { fuzzy: true }) : number;
          const article = articles[parsedNumber - 1];

          if (parsedNumber > 20) {
            alanBtn().playText('Please try that again...');
          }
          else if (article) {
            window.open(article.url, '_blank');
            alanBtn().playText('Opening...');
          }
          else {
            alanBtn().playText('Please try that again...');
          }
        }
      },
    });
  }, []);

  return (
    <React.Fragment>
      <div className={classes.logoContainer}>
        {
          newsArticles.length ? (
          <div className={classes.infoContainer}>
              <div className={classes.card}><Typography variant="h5" component="h2">Try saying: <br /><br />Open article number [4]</Typography>
              </div>

              <div className={classes.card}><Typography variant="h5" component="h2">Try saying: <br /><br />Go back</Typography>
              </div>
          </div>
        )
        : null
      }
        <img src="https://alan.app/voice/images/previews/preview.jpg" className={classes.alanLogo} alt="logo" />
      </div>

       <NewsCards articles={newsArticles} activeArticle={activeArticle} />

        {!newsArticles.length ? (
          <div className={classes.footer}>
            <Typography variant="body1" component="h2">
              Created by
              <a className={classes.link} Somsubhra Mitra href="https://www.linkedin.com/in/somsubhra-mitra-94a889175/"> Somsubhra Mitra</a>
            </Typography>
          </div>
      ):null}
 </React.Fragment>
 )
};

export default App;
